import React, { useState, useEffect, createContext } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Sidebar from "./Sidebar/Sidebar";
import Login from "./Components/Login";
import SignUp from "./Components/Sign_up";
import ForgotPass from "./Components/Forgot_pass";
import ChangePass from "./Components/Change_pass";
import Payments from "./Components/Payments";
import Addproperty from "./Pages/Addproperty";
import Slotproperty from "./Pages/Slotproperty";
import Propertyreview from "./Pages/Propertyreview";
import Managecoupons from "./Pages/Managecoupons";
import Createcoupon from "./Pages/Createcoupon";
import Huntersreview from "./Pages/Huntersreview";
import Realtracking from "./Pages/Realtracking";
import Managearea from "./Pages/Managearea";
import Reservations from "./Pages/Reservations";
import Hunters from "./Pages/Hunters";
import HunterDetails from "./Pages/HunterDetails";
import Profile from "./Components/Profile";
import Editprofile from "./Components/Editprofile";
import PropertyDetails from "./Pages/PropertyDetails";
import ReservationDetails from "./Pages/ReservationDetails";
import RealtrackingDetails from "./Pages/RealtrackingDetails";
import Earnings from "./Pages/Earnings";
import Chats from "./Pages/chats/chats";
import ChangePassword from "./Components/ChangePassword";
import UpcomingReservationsid from "./Pages/UpcomingReservationsid"
import ReservetonsidHistoryid from "./Pages/ReservetonsidHistoryid"
import "./Components/App.css";
import "./Pages/style.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toastify, userlogout } from "./redux/controller";
import PropertyDetailsMap from "./Pages/PropertyDetailsMap";
import Help from "./Pages/help";

export const MyContext = createContext();

function App() {

  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 900px)").matches
  );

  useEffect(() => {

    const updateWidthAndHeight = () => {
      setIsMobile(window.matchMedia("(max-width: 900px)").matches);
    };

    window.addEventListener("resize", updateWidthAndHeight);
    return () => window.removeEventListener("resize", updateWidthAndHeight);
  }, []);


  return (
    <MyContext.Provider value={isMobile}>
      <ToastContainer
        position="top-right"
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={5000}
      />
      <Router>
        <Routes>
          <Route exact path="/" element={<SignUp />} />
        </Routes>
      </Router>
    </MyContext.Provider>
  );
}

export default App;
